import { render, staticRenderFns } from "./pickUp.vue?vue&type=template&id=4a94241c&scoped=true&"
import script from "./pickUp.vue?vue&type=script&lang=ts&"
export * from "./pickUp.vue?vue&type=script&lang=ts&"
import style0 from "./pickUp.vue?vue&type=style&index=0&id=4a94241c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94241c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a94241c')) {
      api.createRecord('4a94241c', component.options)
    } else {
      api.reload('4a94241c', component.options)
    }
    module.hot.accept("./pickUp.vue?vue&type=template&id=4a94241c&scoped=true&", function () {
      api.rerender('4a94241c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pickUp/components/pickUp.vue"
export default component.exports